import React, { Component } from "react";
import { Badge, Button, Card, Cell, Checkbox, DialogContainer, Divider, Grid, SelectField } from "react-md";
import "./PerfomanceAnalytics.css";
import DonutChart from "../charts/DonutChart";
import randomColor from 'randomcolor'
import BarChart from "./charts/BarChart";
import LineChart from "../charts/LineChart";
import TopicAnalytics from "./TopicAnalytics";
import RadialChart from "./charts/RadialChart";
import Toggle from "react-toggle";
import ReactTooltip from "react-tooltip";
import PracticeSetDialog from "../Dashboard/components/practiceSetDialog";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import { BeatLoader } from 'react-spinners';
import RadialAndBarChart from "./charts/RadialAndBarChart";
import ApexLineAreaChart from "./apexCharts/apexLineAreaChart";
import Dashboard from "../Dashboard/Dashboard";
import { AppProperties } from '../../common/functions';
import ApiRequestService from "../../components/ApiRequestService";


const ACCURACY_TOOLTIP = "The accuracy index represents how closely your responses align with the correct answers in the quiz.\nIt indicates the precision of your knowledge and understanding"
const TIME_TOOLTIP = "Time represents the duration it took to complete the category"


class PerformanceAnalytics extends Component {
  appProperties = AppProperties();
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 'byassignments',
      selectedQuizID: null,
      hasPracticeAssignment: true,
      showCarmenSyncDialog: false,
      enabledPractice: false,
    }
  }

  checkIfThisStudentsCourseSectionEnabled() {

    ApiRequestService({
      method: 'get',
      url: '/getStudentCourseSectionPracticeEnabled',
    }).then(res => {
      console.debug("res ==========", res);
      if (res && res.data) {
        if (res.data.data !== undefined && res.data.data !== null) {
            this.setState({
              enabledPractice: res.data.data
            })
        }
      }
    });
  }

  componentDidMount() {
    this.checkIfThisStudentsCourseSectionEnabled()
    this.checkForPracticeAssignment();

    const searchParams = new URLSearchParams(this.props.location.search);
    const quizID = searchParams.get('quizID');
    console.debug("quizID typeof", typeof quizID)
    const { history, location } = this.props;

    const queryParams = new URLSearchParams(location.search);
    const existingTabName = queryParams.get('tabName');

    if (!existingTabName) {
      queryParams.set('tabName', 'byassignments');
      const newUrl = `${location.pathname}?${queryParams.toString()}`;
      history.push(newUrl);
    } else {
      this.setState({
        selectedTab: existingTabName,
        selectedQuizID: quizID ? parseInt(quizID) : null,
      });
    }
  }


  checkForPracticeAssignment() {
    let responsePromise = this.props.apiService({
      method: "GET",
      url: "/checkForPractice",
    });

    responsePromise.then(res => {
      console.debug("res==============", res)
      if (res && res.data) {
        this.setState({
          hasPracticeAssignment: res.data.data
        })
      }
    })
  }

  goToCarmen = () => {
    // NotificationManager.warning('Please start the Practice & Performance assignment from Carmen to sync extra credit', 'How to Sync?', 6000);
    this.setState({
      showCarmenSyncDialog: true
    })
  }

  tabOnChange = (newTabName) => {
    const { history, location } = this.props;

    const queryParams = new URLSearchParams(location.search);
    queryParams.set('tabName', newTabName);
    const newUrl = `${location.pathname}?${queryParams.toString()}`;
    history.push(newUrl);

    let activityTypeID = 1; //By Assignments
    if (newTabName === "sets") {
      activityTypeID = 2 // My Sets
    } else if (newTabName === "performance") {
      activityTypeID = 17 // Topic
    }
     // add activity log
     let logPayload = {
      toNomenclatureID: 0, //Clicked
      quizID: 0,
      subjectID: 0,
      topicID: 0,
      categoryID: 0,
      activityTypeID: activityTypeID,
    };
    if (newTabName !== this.state.selectedTab) {
      this.onAddActivityLog(logPayload)
    }
    
    this.setState({
      selectedTab: newTabName,
      selectedQuizID: null,
    })

  }

  onAddActivityLog = (payload) => {
    console.debug("payload" ,payload);
    let response = this.props.apiService({
      method: "POST",
      url: "/addStudentActivityLog",
      data: payload
    });
    response.then(res => {
      console.debug("res", res)
    }).catch(err => {
      console.debug("err", err)
    })
  }

  render() {

    const actions = [];
    actions.push({
      secondary: true, children: 'Close', onClick: () => {
        this.setState({
          showCarmenSyncDialog: false
        })
      }
    });

    if (!this.state.enabledPractice) {
      return null
    }

    return (
      <div className="position-relative w-100">
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
          integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
          crossorigin="anonymous"
          referrerpolicy="no-referrer"
        />

      <DialogContainer
        id="simple-action-dialog"
        visible={this.state.showCarmenSyncDialog}
        actions={actions}
        title="How to Sync?"
        width={400}
      >
        <div className="fontClass-14">
          <ol>
            <li>
              Launch <a target="_blank" href={`${window.location.hostname === "osu.student.dev.stemfluency.com" ? "https://canvas.ontoborn.com" : "https://osu.instructure.com"}`} style={{
                  color:"#bb0000"
                }}>Carmen</a>
            </li>
            <li>Go to Assignments list and Open the <b>"Practice & Performance"</b> assignment</li>
            <li>And click "Load in New Tab"</li>
          </ol>
        </div>
      </DialogContainer>


        <div className='d-flex justify-content-center w-100 mb-3 tabs-container'>
          <div className='accuracy-time-btn my-2'>
            <div className={this.state.selectedTab === "byassignments" ? 'accuracy-time-selected' : ''} onClick={() => {
              this.tabOnChange("byassignments")
            }}>
              By Assignment


            </div>
            <div className={this.state.selectedTab === "performance" ? 'accuracy-time-selected' : ''} onClick={() => {
              this.tabOnChange("performance")
            }}>
              By Topic

            </div>
            <div className={this.state.selectedTab === "sets" ? 'accuracy-time-selected' : ''} onClick={() => {
              this.tabOnChange("sets")
            }}>
              My Sets

            </div>
          </div>
        </div>
        {/* <div className="extra-credit-btn" style={{
          display: this.appProperties.isLTIStudent ? 'block' : 'none'
        }} >
          {this.state.hasPracticeAssignment ? 
                <Button raised small>✅ Extra credit synced</Button>
            : <Button raised small onClick={this.goToCarmen}>❌ Extra credit not synced</Button>
          }
        </div> */}

        <div className="position-relative" style={{
          marginTop: "4rem"
        }}>
          <div className={`${this.state.selectedTab === "byassignments" ? 'mt-5' : 'all-tabs-container'}`}>
            {this.state.selectedTab === 'byassignments' ? <Dashboard {...this.props} tabName={"byassignments"} selectedQuizID={this.state.selectedQuizID} /> : null}
            {this.state.selectedTab === 'sets' ? <Dashboard {...this.props} tabName={"sets"} selectedQuizID={this.state.selectedQuizID} /> : null}
            {this.state.selectedTab === 'performance' ?
              <PerformanceAndPracticeTab {...this.props} /> : null}
          </div>
        </div>
      </div>
    )
  }
}


export class PerformanceAndPracticeTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      topics: [],
      selectedTopic: null,
      selectedCat: null,
      practiceCategoriesSelected: [],
      categoryPerformanceData: [],
      showPracticeSetDialog: false,
      showBarChart: false,
      showPracticeCreatedDialog: false,
      practiceAssignment: null,
      loading: false,
      catPerfLoading: false,
      selectedTab: 'assignments'
    };
    this.getTopicsForStudent = this.getTopicsForStudent.bind(this);
  }

  componentDidMount() {
    // this.getStudentPerformanceAnalytics();
    this.setState({
      loading: true
    })
    this.getTopicsForStudent();
  }

  onAddActivityLog (payload) {
    console.debug("payload" ,payload);
    let response = this.props.apiService({
      method: "POST",
      url: "/addStudentActivityLog",
      data: payload
    });
    response.then(res => {
      console.debug("res", res)
    }).catch(err => {
      console.debug("err", err)
    })
  }

  onChartTypeChange = (val) => {
    this.setState({
      showBarChart: val
    })

      // add activity log
      let logPayload = {
      toNomenclatureID: val ? 8 : 7, // true ? bar(8) : radial(7)
      quizID: 0,
      subjectID: this.state.selectedTopic.subjectID,
      topicID: this.state.selectedTopic.topicID,
      categoryID: 0,
      activityTypeID: 15, // "Chart chanegd"
    };
    this.onAddActivityLog(logPayload)

  }


  adjust(color, amount) {
    return '#' + color.replace(/^#/, '').replace(/../g, color => ('0' + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2));
  }

  getTopicsForStudent() {
    console.debug("this.props", this.props)
    let responsePromise = this.props.apiService({
      method: "GET",
      url: "/getTopicsForStudent",
    });

    responsePromise.then(res => {
      console.debug("res", res)
      if (res && res.data && res.data.data) {

        let topics = [...res.data.data]
        topics.forEach(topic => {
          topic.categoryAnalytic?.forEach(category => {
            // const color = randomColor({ luminosity: 'bright' });

            // category.color = color;
            category.backgroundColor = this.adjust(category.color, 50);
          });
        });

        console.debug("topics", topics)
        if (topics && topics?.length) {
          let firstCat = topics[0].categoryAnalytic?.length ? topics[0]?.categoryAnalytic[0] : null
          this.setState({
            topics: [...topics,],
            selectedTopic: topics[0],
            selectedCat: firstCat,
            showBarChart: topics[0].categoryAnalytic?.length > 8
          })
          if (firstCat) {
            this.getCategoryPerformance(firstCat, firstCat.key, false, false)
          }
        }


        // this.handleChangeSelectedCategory(0, res.data.data[0].id)
      }
    })
      .finally(() => {
        this.setState({
          loading: false
        })
      })
  }

  getCategoryPerformance(cat, catKey, isTopicChanged, shouldAddLog) {

    if (this.state.selectedTopic === null) return;

    this.setState({
      catPerfLoading: true,
    })

    let payload = {
      subjectID: this.state.selectedTopic.subjectID,
      topicID: this.state.selectedTopic.topicID,
      catKey: catKey
    }

    console.debug("payload", payload)

    let responsePromise = this.props.apiService({
      method: "POST",
      url: "/getAccuracyAndTimeOverTimeByCategory",
      data: payload
    });

    responsePromise.then(res => {
      console.debug("res", res)
      if (res && res.data && res.data.data) {
        this.setState({
          categoryPerformanceData: res.data.data
        })
      }
    }).finally(() => {
      this.setState({
        catPerfLoading: false,
      })

      // add activity log
      let logPayload = {
        toNomenclatureID: 0, // clicked
        quizID: 0,
        subjectID: this.state.selectedTopic.subjectID,
        topicID: this.state.selectedTopic.topicID,
        categoryID: cat.categoryID,
        activityTypeID: isTopicChanged ? 13 : 14 // "Topic" selected
      };

      if (shouldAddLog) {
        this.onAddActivityLog(logPayload)
      }
      
    })
  }

  hexToRgba(hex, alpha) {
    // Remove the # if it exists
    hex = hex.replace('#', '');

    // Parse the hex color to get RGB values
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    // Create the RGBA color with the specified alpha
    const rgbaColor = `rgba(${r}, ${g}, ${b}, ${alpha})`;

    return rgbaColor;
  }

  /*  handleChangeSelectedCategory = (catIndex, topicID) => {
     let topicIndex = this.state.topics.findIndex(topic => topic.id === topicID)
     let topic = this.state.topics[topicIndex]
 
     this.setState({
       selectedCat: topic.categoryAnalytic[catIndex]
     })
   } */


  handleChangeSelectedTopic = (topic) => {
    console.debug("topic", topic)
    let cat = topic.categoryAnalytic?.length ? topic.categoryAnalytic[0] : null
    // if category length is > 8 then hide the radial chart
    if (topic?.categoryAnalytic?.length > 8) {
      this.setState({
        showBarChart: true
      })
    }
    this.setState({
      selectedTopic: topic,
      selectedCat: cat
    })

    if (cat) {
      this.getCategoryPerformance(cat, cat.key, true, false)
    }

    let logPayload = {
      toNomenclatureID: 0, // clicked
      quizID: 0,
      subjectID: topic.subjectID,
      topicID: topic.topicID,
      categoryID: 0,
      activityTypeID: 13, // "Topic" activity in p&p page
    };
    this.onAddActivityLog(logPayload)

  }

  loader = () => {
    return <div style={{ textAlign: 'center', width: '100%', position: 'relative' }}><BeatLoader color={'#bb0000'} size={12} /></div>
  }

  changeSelectedCategory = (cat) => {
    this.setState({
      selectedCat: cat,
    })
    this.getCategoryPerformance(cat,cat.key, false, true)
  }

  handlePracticeCategorySelect(cat, isChecked) {
    console.debug("cat, isChecked", cat, isChecked, this.state)

    let updatedSelectedCategories = [...this.state.practiceCategoriesSelected];

    if (isChecked) {
      updatedSelectedCategories.push(cat);
    } else {
      updatedSelectedCategories = updatedSelectedCategories.filter(
        (catEle) => catEle.key !== cat.key
      );
    }

    console.debug("updatedSelectedCategories", updatedSelectedCategories)

    this.setState({
      practiceCategoriesSelected: updatedSelectedCategories
    })

    let newCats = this.state.selectedTopic.categoryAnalytic.map(c => {
      if (c.key === cat.key) {
        c.checked = isChecked
      }
      return c
    })
    let newSelectedTopic = { ...this.state.selectedTopic }
    newSelectedTopic.categoryAnalytic = newCats;
    console.debug("newSelectedTopic", newSelectedTopic)
    this.setState({
      selectedTopic: newSelectedTopic,
    })

    let logPayload = {
      toNomenclatureID: isChecked ? 5 : 6, // 5-checked, 6-unchecked
      quizID: 0,
      subjectID: this.state.selectedTopic.subjectID,
      topicID: this.state.selectedTopic.topicID,
      categoryID: cat.categoryID,
      activityTypeID: 14, // "Category" activity in p&p page
    };
    this.onAddActivityLog(logPayload)

  }

  handleCreatePracticeSet = () => {

    if (this.state.practiceCategoriesSelected.length === 0) {
      NotificationManager.error("Please select atleast one category to create a new practice set.", "ERROR", 3000);
      return
    }
    this.setState({
      showPracticeSetDialog: true
    })

    let logPayload = {
      toNomenclatureID: 0, // checked
      quizID: 0,
      subjectID: this.state.selectedTopic.subjectID,
      topicID: this.state.selectedTopic.topicID,
      categoryID: 0,
      activityTypeID: 16, // "Create Practice Set"
    };
    this.onAddActivityLog(logPayload)
  }

  handleTakeQuizURL() {
    console.debug("this.state.practiceAssignment", this.state.practiceAssignment);
    let assignment = this.state.practiceAssignment;
    let quizType;
    if (assignment.quizType !== undefined && assignment.quizType !== null) {
      quizType = assignment.quizType
    } else {
      quizType = assignment.quiz_type
    }

    let url = `/takequiz?quiz_id=${assignment.quizID || assignment.quiz_id}&course_id=${assignment.courseID || assignment.course_id}&section_id=${assignment.sectionID || assignment.section_Id}&quiz_name=${assignment.quizName || assignment.quiz_name}&quiz_type=${quizType}`
    this.props.handleRoute(url)
  }


  onCreatePracticeSet = (practiceSetName, checkedCategories) => {
    let quizDetails = [];
    let quizCategoryMasertyCountMap = {}
    let quizCategoryIsRequiredMap = {}
    let quizCategoryPositionMap = {}

    console.debug("checkedCategories", checkedCategories)

    checkedCategories?.forEach((selCat, index) => {
      console.debug("selCat", selCat)
      let catKey = selCat.key
      let subCatKey = `${selCat.key}_${selCat.subcategoryID}`
      quizDetails.push({
        "subject_id": selCat.subjectID,
        "topic_id": selCat.topicID,
        "category_id": selCat.categoryID,
        "subcategory_id": selCat.subcategoryID,
        "index": subCatKey,
        "order": index + 1,
        "question_count": 10, // TODO
        "subcategory_name": selCat.subCategoryName,
        "category_name": selCat.name,
        "randomize_questions": selCat.randomize_questions,
        "random_subcategory_order": 1,
        "subcategory_weight": 1,
        "non_graded": 0,
        "category_mastery_count": 3, // set 3 as a default mastery count | selCat.masteryCount,
        "category_is_required": 1,
        "category_at_last": 0,
        "category_at_begining": 0
      })
      quizCategoryMasertyCountMap[catKey] = 3, // set 3 as a default mastery count | selCat.masteryCount,
        quizCategoryIsRequiredMap[catKey] = 1
      quizCategoryPositionMap[catKey] = {
        "category_at_last": 0,
        "category_at_begining": 0,
      }
    })


    let quizCategoryMasertyCountMapStr = JSON.stringify(quizCategoryMasertyCountMap)
    let quizCategoryIsRequiredMapStr = JSON.stringify(quizCategoryIsRequiredMap)
    let quizCategoryPositionMapStr = JSON.stringify(quizCategoryPositionMap)

    const startDate = moment().subtract(1, 'days');
    const endDate = moment().add(30, 'days');

    let payload = {
      quiz_name: practiceSetName,
      start_date: startDate.format('DD/MM/YYYY'),
      start_time: "00:00",
      end_date: endDate.format('DD/MM/YYYY'),
      end_time: "23:59",
      quiz_type: 0,
      mastery_condition: 3,
      mastery_units: checkedCategories.length,
      maximum_attempted: 2,
      semester_id: 0,
      course_id: -1, // -1 or null
      section_Id: -1, // -1 or null
      quiz_details: quizDetails,
      quiz_id: 0,
      testTimerEnabled: 0,
      fullScoreIfAttempted: 0,
      fixedAbsoluteTimeEnabled: 0,
      randomize_categories: 1,
      sections_list: [],
      splash_screen: <p>{practiceSetName}</p>,
      alt_splash_screen: "",
      NoCQC: 1,
      lockoutN: 20,
      enableSurvey: false,
      category_number_of_questions: '{}',
      category_mastery_count: quizCategoryMasertyCountMapStr,
      category_nocqc: quizCategoryIsRequiredMapStr, // category_nocqc had key and value as quizCategoryIsRequiredMapStr
      random_subcategory_order: quizCategoryIsRequiredMapStr, // random_subcategory_order had key and value as quizCategoryIsRequiredMapStr
      category_is_required: quizCategoryIsRequiredMapStr,
      category_position: quizCategoryPositionMapStr,
      free_choice_count: 0,
      subsection_id: 0,
      enable_subsection: false,
      is_nongraded: 1,
      allow_practice: true
    }

    console.debug("payload", payload)

    // return

    let responsePromise = this.props.apiService({
      method: "post",
      url: "/addQuiz",
      data: payload,
    });

    responsePromise.then(res => {
      console.log("res", res)
      if (res && res.data && res.data.data) {

        this.setState({
          practiceAssignment: res.data.data,
          showPracticeSetDialog: false,
          showPracticeCreatedDialog: true,
        })

        /* let userConfirmed = confirm('Your practice set has been created. Do you want to take it now? If not you can take it later by going to the dashboard "My Sets" tab');
        if (userConfirmed) {
          this.handleTakeQuizURL(res.data.data);
        } */
      }

    })

  }

  handleTopicUpArrow = () => {
    let index = this.state.topics?.findIndex(topic => topic.key === this.state.selectedTopic?.key)
    if (index <= 0) return;
    let selectedIndex = (index - 1 + this.state.topics?.length) % this.state.topics?.length;

    this.handleChangeSelectedTopic(this.state.topics[selectedIndex])
  }


  handleTopicDownArrow = () => {
    let index = this.state.topics?.findIndex(topic => topic.key === this.state.selectedTopic?.key)

    if (index < 0 || index >= this.state.topics.length - 1) return;
    let selectedIndex = (index + 1) % this.state.topics?.length;

    this.handleChangeSelectedTopic(this.state.topics[selectedIndex])
  }

  handleCategoryLeftArrow = () => {
    let index = this.state.selectedTopic?.categoryAnalytic?.findIndex(cat => cat.key === this.state.selectedCat?.key)
    let selectedIndex = 0;
    if (index <= 0) {
      selectedIndex = this.state.selectedTopic?.categoryAnalytic?.length - 1
    } else {
      selectedIndex = (index - 1 + this.state.selectedTopic?.categoryAnalytic?.length) % this.state.selectedTopic?.categoryAnalytic?.length;
    }


    this.changeSelectedCategory(this.state.selectedTopic?.categoryAnalytic[selectedIndex])

  }


  handleCategoryRightArrow = () => {
    let index = this.state.selectedTopic?.categoryAnalytic?.findIndex(cat => cat.key === this.state.selectedCat?.key)
    let selectedIndex = 0
    if (index < 0 || index >= this.state.selectedTopic?.categoryAnalytic?.length - 1) {
      selectedIndex = 0;
    } else {
      selectedIndex = (index + 1) % this.state.selectedTopic?.categoryAnalytic?.length;
    };


    this.changeSelectedCategory(this.state.selectedTopic?.categoryAnalytic[selectedIndex])

  }

  render() {

    const actions = [];
    actions.push({
      secondary: true, children: 'Close', onClick: () => {
        this.setState({
          showPracticeCreatedDialog: false
        })
      }
    });
    actions.push(<Button raised primary onClick={this.handleTakeQuizURL.bind(this)}>Start Practice</Button>);

    if (this.state.loading) {
      return this.loader();
    }

    if (this.state.topics === null || this.state.topics?.length === 0) {
      return <div className="text-center fontClass-22 font-weight-bold" style={{color:"#bb0000", marginTop:"5.5rem"}}>Please come back after completing an assignment to view your performance here.</div>
    }


    return <div className="position-relative w-100">
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
        integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
        crossorigin="anonymous"
        referrerpolicy="no-referrer"
      />
      {this.state.showPracticeCreatedDialog ? 
      <DialogContainer
        id="simple-action-dialog"
        visible={true}
        actions={actions}
        title="Your Practice Set Is Created!"
      >
        <div className="fontClass-14">Do you want to take it now? You can always access it later by selecting the "My Sets" Tab.</div>
      </DialogContainer>
      : null}

      {this.state.showPracticeSetDialog ? 
      <PracticeSetDialog
        showDialog={this.state.showPracticeSetDialog}
        selectedCategories={[...this.state.practiceCategoriesSelected]}
        handleCloseDialog={() => {
          this.setState({
            showPracticeSetDialog: false
          })
        }}
        onCreatePracticeSet={this.onCreatePracticeSet}
        topics={this.state.topics}
      />
      : null}

      <ReactTooltip
        id={"create_new_practice_set"}
        multiline={true}
        place={"bottom"}
        effect="float"
      />
      <div className="topic-set-btn" data-for={`create_new_practice_set`}
        data-tip={this.state.practiceCategoriesSelected.length > 0 ? null : "Please select atleast one category from any topics to create a practice set."}
        style={{
          backgroundColor: this.state.practiceCategoriesSelected.length ? '#bb0000' : '#808080'
        }}
        onClick={() => {
          if (this.state.practiceCategoriesSelected.length) {
            this.handleCreatePracticeSet()
          }
        }}
      >

        Create Practice Set
        {this.state.practiceCategoriesSelected?.length ?
          <span className="floating-number">{this.state.practiceCategoriesSelected?.length}</span>
          : null}

      </div>

      <div className="set-btn shadow-sm d-none">
        <ReactTooltip
          id={"create_new_practice_set"}
          multiline={true}
          place="bottom"
          effect="float"
        />
        <div>
          <Badge badgeContent={this.state.practiceCategoriesSelected.length} invisibleOnZero primary badgeId="selected-cat-count" badgeStyle={{
            backgroundColor: 'white',
            color: '#bb0000',
            fontWeight: "bold",
            border: '1px solid black',
            // left: 0,
            // top: -15,
            fontSize: "14px"
          }}>
            <div
              className=""
              data-for={`create_new_practice_set`}
              data-tip={this.state.practiceCategoriesSelected.length > 0 ? null : "Please select atleast one category from any topics to create a practice set."}
              onClick={() => {
                if (this.state.practiceCategoriesSelected.length) {
                  this.handleCreatePracticeSet()
                }
              }}
              style={{
                backgroundColor: this.state.practiceCategoriesSelected.length ? '#bb0000' : '#808080'
              }}
            >
              Create New Practice Set
            </div>
          </Badge>


        </div>

      </div>

      {/* <RadialAndBarChart categories={this.state.selectedTopic?.categoryAnalytic} /> */}
      <div className="perf-container">

        <div className="floating-topics-container">
          {/* <div className="font-weight-bold fontClass-18 bg-white text-align-center w-100">Topics</div> */}
          <div className="arrow" onClick={this.handleTopicUpArrow}>
            <i class="fas fa-chevron-up"></i>
          </div>
          <div className="floating-topics">
            {this.state.topics?.map(topic => {
              return <div key={topic.key}
                className={this.state.selectedTopic.key === topic.key ? "topic selected-topic" : "topic"}
                onClick={() => {
                  this.handleChangeSelectedTopic(topic)
                }}>
                <span className="floating-topic-chart">
                  <RadialChart categories={topic.categoryAnalytic ? [...topic.categoryAnalytic].slice(0, 6) : []} width={"50px"} showTooltip={false} />
                </span>
                <div className="text-align-center fontClass-12 pt-1">{topic.name}</div>
              </div>
            })}
          </div>

          <div className="arrow" onClick={this.handleTopicDownArrow}>
            <i class="fas fa-chevron-down"></i>
          </div>
        </div>
        <div className="main-container">
          {/* <div className="text-align-left fontClass-20 font-weight-bold">Performance Analytics</div> */}
          <div className="pl-3">
            <h2 className="text-align-left font-weight-bold p-0 m-0">{this.state.selectedTopic?.name}</h2>
            <div className="text-align-left fontClass-12">Your Performance by Accuracy & Time </div>
          </div>
          <Grid className="m-0 p-0">
            <Cell size={1}></Cell>
            <Cell size={10} tabletSize={12} phoneSize={12} className="main-chart-container">
              <div className="chart-icon-btn-container my-2" style={{
                display: this.state.selectedTopic?.categoryAnalytic?.length > 8 ? 'none' : 'flex'
              }}>
                <div className="chart-icon-btn" style={{
                  borderRight: !this.state.showBarChart && "1px solid #707070",
                  background: !this.state.showBarChart ? "#C7C7C7" : "white",
                }} onClick={() => {
                  // this.setState({
                  //   showBarChart: false,
                  // })
                  this.onChartTypeChange(false)
                }}>
                  <img width="30" height="30" src="https://img.icons8.com/external-basicons-line-edtgraphics/50/external-Radial-chart-charts-basicons-line-edtgraphics-2.png" alt="external-Radial-chart-charts-basicons-line-edtgraphics-2" />
                </div>
                <div className="chart-icon-btn" style={{
                  borderLeft: this.state.showBarChart && "1px solid #707070",
                  background: this.state.showBarChart ? "#C7C7C7" : "white",
                }} onClick={() => {
                  // this.setState({
                  //   showBarChart: true,
                  // })
                  this.onChartTypeChange(true)
                }}>
                  <img width="30" height="30" src="https://img.icons8.com/sf-ultralight-filled/50/bar-chart.png" alt="bar-chart" />
                </div>
              </div>
              <div className="d-flex justify-content-around align-items-start">
                {this.state.showBarChart ?
                  <BarChart
                    categories={this.state.selectedTopic?.categoryAnalytic}
                    topicID={this.state.selectedTopic?.id}
                    selectedTopic={this.state.selectedTopic}
                    selectedCat={this.state.selectedCat}
                    handleChangeSelectedCategory={this.changeSelectedCategory}
                    handlePracticeCategorySelect={this.handlePracticeCategorySelect.bind(this)}
                  />
                  :
                  <RadialAndBarChart
                    categories={this.state.selectedTopic?.categoryAnalytic ? [...this.state.selectedTopic?.categoryAnalytic] : []}
                    selectedCategories={[...this.state.practiceCategoriesSelected]}
                    topicID={this.state.selectedTopic?.id}
                    selectedTopic={this.state.selectedTopic}
                    selectedCat={this.state.selectedCat}
                    handleChangeSelectedCategory={this.changeSelectedCategory}
                    isBarChart={false}
                    handlePracticeCategorySelect={this.handlePracticeCategorySelect.bind(this)}
                  />
                }
              </div>


            </Cell>

            <Cell size={4} tabletSize={12} phoneSize={12} align="middle" className="cat-list-mob-container">
              <div className="text-secondary fontClass-16 text-center mb-3 font-weight-bold d-none">
                Cateogories Ranked by Accuracy Index Scores
              </div>
              <div className="cat-list">
                <div className="d-flex justify-content-end w-100">
                  <div className="text-align-center fontClass-12 text-secondary font-weight-bold w-25">Add To Practice</div>
                </div>
                {this.state.selectedTopic?.categoryAnalytic?.map((cat, index) => {
                  return (
                    <div
                      className="single-cat cursor-pointer"
                      key={cat.key}
                      style={{
                        background:
                          this.state.selectedCat?.name === cat.name
                            ? "#ededed"
                            : "",
                      }}
                    >
                      <div className="d-flex justify-content-center align-items-center w-100">
                        <div>
                          <div
                            className="circle mr-2"
                            style={{
                              backgroundColor: cat.backgroundColor,
                            }}
                          ></div>
                        </div>
                        <div
                          onClick={() => {
                            this.changeSelectedCategory(cat)
                          }}
                          className="px-2 w-100"
                        >
                          {cat.label ? cat.label : cat.name} ({cat.timeInSec}sec)
                        </div>
                      </div>
                      <div >
                        <ReactTooltip
                          id={`add_to_practice_set_${cat.key}`}
                          multiline={true}
                          place="top"
                          effect="float"
                        />
                        <Checkbox id={index} checked={cat.checked} onChange={(val) => {
                          console.debug("val", val)
                          this.handlePracticeCategorySelect(cat, val)
                        }}
                          data-for={`add_to_practice_set_${cat.key}`}
                          data-tip={cat.checked ? "Remove from practice set" : "Add to practice set"}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </Cell>
            <Cell size={12} phoneSize={10} className="">
              {/* <h3 className="text-align-center mb-4 mt-2">Performance by Category</h3> */}
              <div className="d-flex justify-content-center cat-container-parent cat-arrows">
                <div className="arrow arrow2 arrow-active" onClick={this.handleCategoryLeftArrow}
                  style={{
                    display: this.state.selectedTopic?.categoryAnalytic?.length > 1 ? 'flex' : 'none'
                  }}
                >
                  <i class="fas fa-caret-left"></i>
                </div>
                <div className="cat-container d-none">
                  {this.state.selectedTopic?.categoryAnalytic?.map(cat => {
                    return <div className="cat-btn p-2" key={cat.key} style={{
                      background: this.state.selectedCat?.key === cat.key ? "#666" : "",
                      color: this.state.selectedCat?.key === cat.key ? "white" : "black",
                    }} onClick={() => {
                      this.changeSelectedCategory(cat)
                    }}>
                      {cat.name}
                    </div>
                  })}
                </div>
                <div className="arrow arrow2 arrow-active" onClick={this.handleCategoryRightArrow}
                  style={{
                    display: this.state.selectedTopic?.categoryAnalytic?.length > 1 ? 'flex' : 'none'
                  }}
                >
                  <i class="fas fa-caret-right"></i>
                </div>
                {/* <Button floating primary mini>
                <i class="fas fa-caret-right" style={{width:'12px', height:'12px'}}></i>
              </Button> */}
              </div>
            </Cell>

            <Cell size={12}>
              <div className="pl-3">
                <div className="text-align-left fontClass-20 font-weight-bold">{this.state.selectedCat?.label ? this.state.selectedCat?.label : this.state.selectedCat?.name}</div>
                <div className="text-align-left fontClass-12">Performance by Category</div>
              </div>
            </Cell>
            <Cell size={6} phoneSize={12}>
              <div className="fontClass-14 text-center font-weight-bold">Accuracy Index
                <small
                  data-tip={ACCURACY_TOOLTIP}
                  data-for='accuracy_heading'>
                  <i className="fa-solid fa-circle-info ml-2 text-secondary" ></i>
                </small>
              </div>
              <ReactTooltip
                id={`accuracy_heading`}
                multiline={true}
                place="top"
                className='tool-tip tooltip-css'
                effect="float" />
              <div className="d-none justify-content-center align-items-center mt-0">
                <Toggle
                  id="compare_with_classmates_accuracy"
                  icons={false}
                  className="mr-2"
                  onChange={() => {

                  }}
                />
                <label htmlFor='compare_with_classmates_accuracy' className="mt-2">compare with classmates</label>
              </div>
              <div>
                {/* <LineChart /> */}
                <ApexLineAreaChart
                  labels={[...this.state.categoryPerformanceData?.map((cat, index) => {
                    if (index === this.state.categoryPerformanceData?.length - 1) {
                      return 'Last Attempt'
                    }
                    return `${index + 1}`
                  })]}
                  values={[...this.state.categoryPerformanceData?.map(cat => {
                    return cat.accuracyIndex
                  })]}
                  selectedCat={this.state.selectedCat}
                  xAxisLabel="Attempt #"
                  yAxisLabel={"Accuracy %"}
                  seriesName="Accuracy Index"
                  loading={this.state.catPerfLoading}
                />

                {/* <LineChart
                showBorder={true}
                xAxisLabel="No. of Attempts"
                yAxisLabel={"Accuracy %"}
                // chartName={"Accuracy Index Over Time"}
                chartNameTooltip={"Accuracy Index Over Time"}
                labels={["1", ...this.state.categoryPerformanceData?.map((cat, index) => {
                  return `${index + 2}`
                })]}
                values={this.state.categoryPerformanceData?.map(cat => {
                  return { value: cat.accuracyIndex, color: 'white' }
                })}

                // labels={["", "09/01", "09/08", "09/15", "09/22", "09/29"]}
                // values={[
                //   { value: 20, color: "white" },
                //   { value: 34, color: "white" },
              //   { value: 54, color: "white" },
                //   { value: 76, color: "white" },
                //   { value: 91, color: "white" },
                // ]}
                pointBorderColor="#333"
                borderColor="#741A76"
                borderWidth={1.5}
                pointRadius={3}
                width={150}
                height={80}
              /> */}
              </div>
            </Cell>
            <Cell size={6} phoneSize={12}>
              <div className="fontClass-14 text-center font-weight-bold">Time
                <small
                  data-tip={TIME_TOOLTIP}
                  data-for='time_heading'>
                  <i className="fa-solid fa-circle-info ml-2 text-secondary" ></i>
                </small>
              </div>

              <ReactTooltip
                id={`time_heading`}
                multiline={true}
                place="top"
                className='tool-tip tooltip-css'
                effect="float" />
              <div className="d-none justify-content-center align-items-center mt-0">
                <Toggle
                  id="compare_with_classmates_time"
                  icons={false}
                  className="mr-2"
                  onChange={() => {

                  }}
                />
                <label htmlFor='compare_with_classmates_time' className="mt-2">compare with classmates</label>
              </div>
              <div>
                {/* <LineChart /> */}
                <ApexLineAreaChart
                  labels={[...this.state.categoryPerformanceData?.map((cat, index) => {
                    if (index === this.state.categoryPerformanceData?.length - 1) {
                      return 'Last Attempt'
                    }
                    return `${index + 1}`
                  })]}
                  values={this.state.categoryPerformanceData?.map(cat => {
                    return cat.timeInSec
                  })}
                  selectedCat={this.state.selectedCat}
                  xAxisLabel="Attempt #"
                  yAxisLabel={"Time Sec."}
                  isTimeChart={true}
                  seriesName="Time In Sec"
                  loading={this.state.catPerfLoading}
                />

                {/*  <LineChart
                showBorder={true}
                xAxisLabel="No. of Attempts"
                yAxisLabel={"Time Sec."}
                // chartName={"Time per Question Over Time"}
                chartNameTooltip={"Time per Question Over Time"}
                labels={["1", ...this.state.categoryPerformanceData?.map((cat, index) => {
                  return `${index + 2}`
                })]}
                values={this.state.categoryPerformanceData?.map(cat => {
                  return { value: cat.timeInSec, color: 'white' }
                })}

                // labels={["", "09/01", "09/08", "09/15", "09/22", "09/29"]}
                // values={[
                //   { value: 320, color: "white" },
                //   { value: 234, color: "white" },
                //   { value: 194, color: "white" },
                //   { value: 176, color: "white" },
                //   { value: 201, color: "white" },
                // ]}
                pointBorderColor="#333"
                borderColor="#741A76"
                borderWidth={1.5}
                pointRadius={3}
                width={150}
                height={80}
              /> */}
              </div>
            </Cell>
          </Grid>
          <br /><br /><br />
        </div>
      </div>
    </div>
  }

}


export default PerformanceAnalytics